var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.05,3.555A2,2,0,0,1,2,2H14a2,2,0,0,1,1.95,1.555L8,8.414ZM0,4.7v7.1L5.8,8.243ZM6.761,8.83.191,12.857A2,2,0,0,0,2,14H14a2,2,0,0,0,1.808-1.144L9.238,8.829,8,9.586,6.761,8.829ZM10.2,8.244,16,11.8V4.7L10.2,8.243Z",
    transform: "translate(0 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeFill);
export default __webpack_public_path__ + "static/media/envelope-fill.2f1d5ea46fb6cba3c7ff0d5aad6d6c5c.svg";
export { ForwardRef as ReactComponent };